export default "__VITE_ASSET__VE7OIjhk__"